export default __webpack_public_path__ + "static/media/chomp-head.7785547e.png";